import Button from "/components/Button";
import { withTranslation } from "react-i18next";
import classNames from "classnames";

export default withTranslation()(function ContactButton({
  t,
  setIsModalOpen,
  mobile = false,
}) {
  const openModal = () => setIsModalOpen(true);

  return (
    <div className={classNames("contact-button-wrapper", { "contact-button-wrapper--mobile": mobile })}>
      <Button
        onClick={openModal}
        className="btn btn--dark"
      >
        {t("projects.contact")}
      </Button>
    </div>
  );
});
